<template>
  <div class="sendInfor">
    <div class="content">
      <page-logo />
      <page-table-list />
    </div>
    <page-footer />
  </div>
</template>

<script>
import pageLogo from "./pages/logo";
import pageTableList from "./pages/tableList";
import pageFooter from "./pages/footer";
export default {
  components: {
    pageLogo,
    pageTableList,
    pageFooter,
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 980px;
  margin: 0 auto;
}
</style>
